import { useAuth0 } from '@auth0/auth0-react';
import { CircularProgress, Grid } from '@material-ui/core';
import { InputField } from 'components/InputField/InputField';
import { useFormik } from 'formik';
import FinanceService from 'Lib/API/Finance';
import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import Button from '../button/Button';
import addAchCardValidationSchema from './addAchCardValidationSchema';
import { AddAchCardCardTitle } from './Theme';

const AddAchCard = ({
  style = {},
  labelStyle = {},
  closeModal,
  refetchAchCards,
  openVerifyInfoModal
}) => {
  const { getAccessTokenSilently } = useAuth0();
  let accountID = localStorage.getItem("accountID")
    ? localStorage.getItem("accountID")
    : "";

  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {
      achDetails: {
        accountType: "",
        accountNumber: "",
        routingNumber: "",
        nameOnAccount: "",
      },
    },
    validationSchema: addAchCardValidationSchema,
    onSubmit: async (values) => {
      const accountDetail = {
        type: values?.achDetails?.accountType,
        number: values?.achDetails?.accountNumber,
        routing: values?.achDetails?.routingNumber,
        name: values?.achDetails?.nameOnAccount,
      };
      addAchCardHandler(accountDetail);
    },
  });

  const addAchCardHandler = async () => {
    setIsLoading(true);
    const token = await getAccessTokenSilently();

    const accountDetail = {
      type: formik?.values?.achDetails?.accountType,
      number: formik?.values?.achDetails?.accountNumber,
      routing: formik?.values?.achDetails?.routingNumber,
      name: formik?.values?.achDetails?.nameOnAccount,
    };

    FinanceService.addACHAccount(
      token,
      accountID,
      accountDetail
    )
      .then((res) => {
        toastr.success("Success", "ACH Added Successfully");
        resetForm();
        closeModal();
        openVerifyInfoModal();
        refetchAchCards();
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.data?.message ?? "Please enter valid card details"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const resetForm = () => {
    formik.resetForm();
  }


  return (
    <div className='d-flex flex-column align-items-center' style={{
      gap: "20px",
    }}>
      <AddAchCardCardTitle>Add New ACH Card</AddAchCardCardTitle>
      <Grid container spacing={3}>
        <Grid item xs={12}  md={6}>
          <InputField
            placeholder='Account Type'
            styleWrapper={{ width: '100%' }}
            style={style}
            labelStyle={labelStyle}
            mandatory
            {...{
              formik,
              label: "Account Type",
              name: "achDetails.accountType",
              type: "string",
              // value: "checking",
            }}
          />
        </Grid>
        <Grid item xs={12}  md={6}>
          <InputField
            placeholder='Account Number'
            styleWrapper={{ width: '100%' }}
            style={style}
            labelStyle={labelStyle}
            mandatory
            {...{
              formik,
              label: "Account Number",
              name: "achDetails.accountNumber",
              type: "string",
            }}
          />
        </Grid>
        <Grid item xs={12}  md={6}>
          <InputField
            placeholder='Routing Number'
            styleWrapper={{ width: '100%' }}
            style={style}
            labelStyle={labelStyle}
            mandatory
            {...{
              formik,
              label: "Routing Number",
              name: "achDetails.routingNumber",
              type: "string",
            }}
          />
        </Grid>
        <Grid item xs={12}  md={6}>
          <InputField
            placeholder='Name on Account'
            styleWrapper={{ width: '100%' }}
            style={style}
            labelStyle={labelStyle}
            mandatory
            {...{
              formik,
              label: "Name on Account",
              name: `achDetails.nameOnAccount`,
            }}
          />
        </Grid>
      </Grid>
      <div className="add-button">
        <Button
          style={{ minWidth: "150px" }}
          onClick={formik.handleSubmit}
          variant="primary"
          size="md"
          disabled={!formik.isValid || isLoading}
        >
          {isLoading ?
            <CircularProgress color="#FFFFFF" size={20} />
            : "Add ACH Card"}
        </Button>
      </div>
    </div>
  )
}

export default AddAchCard